var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "permissions-page",
      staticStyle: { margin: "90px" },
    },
    [
      _c(
        "el-header",
        { staticStyle: { height: "100px", "margin-top": "20px" } },
        [
          _c(
            "span",
            {
              staticClass: "ring-card__header-buttons",
              staticStyle: { margin: "0px 0px 20px 0px", float: "right" },
            },
            [
              _c("RefreshButton", {
                nativeOn: {
                  click: function ($event) {
                    return _vm.refresh(true)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", color: "#1998d5" } },
            [_c("h2", [_vm._v("Manage Permissions")])]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { height: "50px" } },
        [
          _c(
            "el-tooltip",
            { attrs: { content: "Create Permission" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", "font-size": "14px" },
                  attrs: { size: "medium", type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openNewPermissionDialog()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _vm._v("\n        Create\n      "),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-input",
            {
              staticStyle: {
                "font-size": "14px",
                margin: "0px 10px 20px 0px",
                float: "right",
                width: "300px",
              },
              attrs: {
                placeholder: "Find by Resource or Action",
                clearable: "",
                type: "text",
              },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            },
            [
              _c("i", {
                staticClass: "el-input__icon el-icon-search",
                attrs: { slot: "prefix" },
                slot: "prefix",
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.filteredPermissionList, function (permission) {
        return _c(
          "el-card",
          {
            key: permission.index,
            staticStyle: { width: "100%" },
            attrs: { index: permission.id, shadow: "hover" },
          },
          [
            _c(
              "div",
              { staticClass: "card-footer" },
              [
                _c(
                  "el-collapse",
                  { staticStyle: { border: "none" } },
                  [
                    _c("h3", [_vm._v(_vm._s(permission.resource))]),
                    _vm._v(" "),
                    _c(
                      "el-collapse-item",
                      [
                        _c("template", { slot: "title" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "18px",
                                "margin-top": "-40px",
                                color: "grey",
                              },
                            },
                            [_vm._v(_vm._s(permission.action))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("permission-details", {
                          attrs: { permission: permission },
                          on: { reload: _vm.loadPermissions },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "30%",
            "show-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("span", { staticStyle: { "margin-left": "40px" } }, [
            _c("img", {
              staticClass: "icon",
              attrs: { src: _vm.icons.warning },
            }),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "dialog_title_style" }, [
            _vm._v("\n      Delete this permission?\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { padding: "30px" } }, [
            _c("div", { staticClass: "dialog_item_style" }, [
              _c("span", { staticStyle: { "margin-right": "20px" } }, [
                _vm._v("Resource:"),
              ]),
              _c("b", [_vm._v(_vm._s(_vm.dialogResource))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dialog_item_style" }, [
              _c("span", { staticStyle: { "margin-right": "40px" } }, [
                _vm._v("Action:"),
              ]),
              _c("b", [_vm._v(_vm._s(_vm.dialogAction) + " ")]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deletePermission(_vm.dialogPermissionId)
                    },
                  },
                },
                [_vm._v("Confirm")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogCreatePermissionVisible,
            width: "30%",
            "show-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogCreatePermissionVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog_title_style" }, [
            _vm._v("\n      Create permission\n    "),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "dialog_create_form_style",
              attrs: {
                model: _vm.createForm,
                disabled: !_vm.createForm.resource,
              },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.createPermission(
                    _vm.createForm.resource,
                    _vm.createForm.action
                  )
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _c("div", { staticClass: "dialog_create_item_title_style" }, [
                    _vm._v("\n          Resource:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { "max-width": "400px" },
                    attrs: {
                      required: "",
                      placeholder: "Permission Name",
                      input: "string",
                    },
                    model: {
                      value: _vm.createForm.resource,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "resource", $$v)
                      },
                      expression: "createForm.resource",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog_create_item_style" },
                [
                  _c("div", { staticClass: "dialog_create_item_title_style" }, [
                    _vm._v("\n          Action:\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { "max-width": "400px" },
                    attrs: {
                      required: "",
                      placeholder: "Action",
                      input: "string",
                    },
                    model: {
                      value: _vm.createForm.action,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "action", $$v)
                      },
                      expression: "createForm.action",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogCreatePermissionVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled:
                      !_vm.createForm.resource || !_vm.createForm.action,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.createPermission(
                        _vm.createForm.resource,
                        _vm.createForm.action
                      )
                    },
                  },
                },
                [_vm._v("Create")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }